<template>
    <div class="home">
        <!-- footer -->
        <div class="footer">

            <div class="container footer-inner">

                <div class="footer-left">

                    <div class="site-logo">

                        <!-- logo图 -->
                        <img class="logo-img" src="@/assets/images/home/logo.png" alt="" />

                        <!-- 文字 -->
                        <div class="logo-text">

                            <div class="cn-title">
                                中国人力资源开发研究会风险管理分会
                            </div>

                            <div class="en-title">
                                Risk management association of china
                            </div>

                        </div>

                    </div>

                </div>

                <img class="qrcode" src="@/assets/images/home/ewm.png" alt="" />

            </div>

            <!-- <div class="footer-bottom">
                <p>联系人：温老师130、李老师 130</p>
                <p>联系地址：北京市顺义区裕华路27号南二门3号楼</p>
            </div> -->

        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterBottom'

}
</script>
<style lang="scss" scoped>
.site-logo {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.logo-img {
    width: 72px;
    height: 72px;

    object-fit: contain;
}

.logo-text {
    margin-left: 18px;
}

.cn-title {
    font-size: 28px;
    color: #333;

    font-weight: 500;

    line-height: 1.2;
}

.container {
    width: 1200px;
    max-width: calc(100% - 30px);
    margin: 0 auto;
}

/* 友情链接 */
.friend-link {
    margin-top: 40px;
    padding: 30px 0;
}

.friend-title {
    font-size: 30px;
    margin-bottom: 20px;
}

.friend-list {
    color: #666;
    line-height: 2.4;

    span {
        margin-right: 20px;
    }
}

/* footer */
.footer {
    width: 100%;
    background: #fff;
    border-top: 4px solid #CC0000;
    margin-top: 30px;
}

.footer-inner {
    height: 160px;

    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footer-left {
    display: flex;
    align-items: center;
}

.footer-logo {
    height: 60px;
}

.footer-name {
    font-size: 32px;
    margin-left: 20px;
}

.qrcode {
    width: 120px;
    height: 120px;
}

.footer-bottom {
    width: 1200px;
    margin: 0 auto;
    height: 90px;
    border-top: 1px solid #eee;
    text-align: center;

    // display: flex;
    // align-items: center;
    // justify-content: space-between;

    // color: #999;
    p {
        margin-top: 14px;
    }
}

.footer-bottom .footer-right a {
    height: 4px;
    border-left: 1px solid #999;
    padding: 0 20px;
}

.footer-bottom .footer-right a:nth-child(1) {
    border: none;

}

.menu-btn {
    display: none;
}

.en-title {
    text-align: center;
    margin-top: 6px;

    font-size: 22px;

    color: #555;
}

@media screen and (max-width: 768px) {
    .footer-inner {
    height: 100px;
}
    .qrcode {
        width: 67px;
        height: 67px;
    }

    .footer-bottom {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;

        flex-direction: column;
        justify-content: center;

        height: auto;

        padding-top: 15px;
        padding-bottom: 15px;
    }

    .footer-right {
        margin-top: 10px;
    }

    .logo-wrap {
        width: 100%;
        align-items: center;
    }

    .logo {
        width: 100px;
    }

    .site-logo {

        // width: 220px;
        .logo-img {
            width: 30px;
            height: 30px;
        }

        .cn-title {
            font-size: 12px;
        }
    }

    .logo-img {
        width: 42px;
        height: 42px;
    }

    .logo-text {
        margin-left: 10px;
    }

    .cn-title {
        font-size: 18px;
    }

    .en-title {
        font-size: 11px;
        line-height: 1.4;
    }
}
</style>